import React, { useState } from "react";
import { observer } from "mobx-react";
import { navigate } from "@reach/router";
import { EMAIL_REGEX } from "../../../constants";
import { useBreakpoints } from "../../../hooks/useBreakpoints";
import useOnEnterPressed from "../../../hooks/useOnEnterPressed";
import { Input, Button } from "../../../components/-common";
import "./VerifyEmail.scss";

const VerifyEmail = observer(() => {
  const { isMobile } = useBreakpoints();
  
  const [email, setEmail] = useState("");
  const updateEmail = ({ target }) => {
    setError();
    setEmail(target.value);
  };

  const [error, setError] = useState();

  const continueEnabled = email?.match(EMAIL_REGEX);
  const continueToVerification = () => {
    if (continueEnabled) {
      navigate("/auth/verify", { state: { email, fromManualEntry: true } });
    }
  };
  useOnEnterPressed(continueToVerification);

  const backToLogIn = () => navigate("/auth");

  const instructions = (
    <div className="right-col">
      <h1 className="hero-text">Need to verify your account?</h1>
      <p className="helper-text">
        If you've already signed up but haven't verified your email yet, enter your email address below 
        and we'll take you to the verification page.
      </p>
      <p className="helper-text">
        You'll be able to resend the verification code if needed.
      </p>
    </div>
  );

  return (
    <div className="verify-email">
      {isMobile ? instructions : null}
      <div className="left-col">
        <div className="verify-email-content">
          <div className="verify-email-square">
            <div className="verify-email-inputs">
              <Input
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={updateEmail}
                error={error}
                autoComplete="email"
              />
              <Button
                type="cta"
                className="continue-button"
                action={continueToVerification}
                disabled={!continueEnabled}
              >
                Continue to Verification
              </Button>
            </div>
            <div className="back-to-login">
              <span>Changed your mind?</span>
              <Button type="cta" className="back-button" action={backToLogIn}>
                Back to Log In
              </Button>
            </div>
          </div>
        </div>
      </div>
      {isMobile ? null : instructions}
    </div>
  );
});

export default VerifyEmail;